import type { Translate } from '@/shared/api/errors'

const STAKEHOLDER_TXN_KIND =
  /\b(INITIAL_INVESTMENT|CAPITAL_CONTRIBUTION|WITHDRAWAL|ADJUSTMENT|OTHER|PROFIT_DISTRIBUTION|LOSS_ALLOCATION|PROFIT_PAYMENT|ADVANCE|DEBT_REPAYMENT|REVERSAL)\b/g

/**
 * Ta'sischi provodkasining izohini server `<kod> <TxnKind>` shaklida yozadi.
 * Enum nomi ekranda xom qolmasin — tarjimasi bilan almashtiriladi.
 * Operator yozgan izohlarga (xarajat, xarid) tegilmaydi.
 */
export function journalMemo(entry: { kind: string; memo: string | null }, t: Translate): string | null {
  if (entry.memo === null) return null
  if (entry.kind !== 'STAKEHOLDER' && entry.kind !== 'REVERSAL') return entry.memo
  return entry.memo.replace(STAKEHOLDER_TXN_KIND, (kind) => t(`stakeholder.txnKind.${kind}`))
}
